<mat-chip-listbox aria-label="status" class="log-status">
    <mat-chip-option *ngIf="this.status == 'E'" class="error" selected>Error</mat-chip-option>
    <mat-chip-option *ngIf="this.status == 'W'" class="warning" selected>Warning</mat-chip-option>
    <mat-chip-option *ngIf="this.status == 'S'" class="success" selected>Success</mat-chip-option>
</mat-chip-listbox>